<div class="row align-items-center" style="border-bottom: 1px solid #5d2041; margin-top: 1px solid #5d2041; height:68.6px">
    <div class="col">
      <div class="eventsheader">Account Settings</div>
    </div>
    
  </div>
  
  <div style="background-color:rgb(241, 235, 228)">
<div class="d-flex p-2 profileheader">
    <img class="userimage" src="{{userInfo.avatar === null ? 'https://i.pinimg.com/originals/51/f6/fb/51f6fb256629fc755b8870c801092942.png': userInfo.avatar}}">
    <div class="name">
        {{userInfo.first_name}} {{userInfo.last_name}}
        <br>
        <label class="country">{{userInfo.country}}</label>
    </div>
</div>


<mat-list>
    <div>Lebtivity will send notifications to your email address registered with us. You can turn these notifications on and off according to your preference.</div>
    <div class="row">
    <div class="col-sm">
    <mat-list-item class="listtitle"><span class="material-icons">
            notifications
        </span>Notifications</mat-list-item>
    <mat-divider></mat-divider>
    <div class="listitem">
        <mat-checkbox [checked]="userInfo.notification == 0 ? false : true" (change)="notification($event)">E-Mail Notifications</mat-checkbox>
    </div>
    <div class="hints">Notify me by email about the status of my events</div>
    <br>
    <div class="listitem">
        <mat-checkbox >Newsletter</mat-checkbox>
    </div>
    <div class="hints">Sign up to our newsletter</div>
</div>

    <!-- <mat-list-item class="listtitle"><span class="material-icons">
            settings
        </span>General</mat-list-item>
    <mat-divider></mat-divider>
    <label style="display:inline-block" class="listitem">Country</label>

    <form [formGroup]="countryFormGroup">
        <mat-select-country appearance="outline" [countries]="predefinedCountries" label="" formControlName="country"
            (onCountrySelected)="onCountrySelected($event)">
        </mat-select-country>
    </form> -->

    <div class="col-sm">
    <mat-list-item class="listtitle"><span class="material-icons">
            person
        </span>Account</mat-list-item>
        <mat-divider></mat-divider>
        <label *ngIf="showResetPassword" (click)="openResetPassword()" class="listitem">Reset Password</label>
        <br>
        <label class="deactivateaccount" (click)="deactivateAccount()">Deactivate Account</label>
    </div>
</div>
  </mat-list>

  <div>
  <br />
</div>
</div>